<template>
  <div class="iframe-wrap">
    <iframe
      :src="`/pdfjs/web/viewer.html?file=${encodeURIComponent(fileUrl)}`"
      frameborder="0"
      class="frame"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'FilePreview',

  computed: {
    fileUrl() {
      return this.$route.query.fileUrl
    }
  }
}
</script>

<style scoped lang="scss">
.iframe-wrap {
  margin: 0 auto;
  width: 100%;
  height: 100vh;

  .frame {
    width: 100%;
    height: 100%;
  }
}
</style>
